import { render, staticRenderFns } from "./RewardsSubmit.vue?vue&type=template&id=4025ce82&scoped=true"
import script from "./RewardsSubmit.vue?vue&type=script&lang=js"
export * from "./RewardsSubmit.vue?vue&type=script&lang=js"
import style0 from "./RewardsSubmit.vue?vue&type=style&index=0&id=4025ce82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025ce82",
  null
  
)

export default component.exports